interface ChaosControlProps {
  cooldownLabel: string;
  ready: boolean;
  disabled: boolean;
  onTrigger: () => void;
}

export default function ChaosControl({
  cooldownLabel,
  ready,
  disabled,
  onTrigger,
}: ChaosControlProps) {
  return (
    <div className="mt-[clamp(0.75rem,2vh,1rem)] flex flex-col items-center gap-2">
      <button
        onClick={onTrigger}
        disabled={!ready || disabled}
        className={`rounded-full border-2 px-[clamp(1.5rem,3vw,2.25rem)] py-[clamp(0.5rem,1.2vh,0.75rem)] text-[clamp(0.7rem,1.3vw,0.875rem)] font-bold uppercase tracking-widest transition ${
          ready && !disabled
            ? "border-yellow-400 text-yellow-300 shadow-[0_0_20px_rgba(250,204,21,0.25)] hover:bg-yellow-400 hover:text-black"
            : "cursor-not-allowed border-white/10 text-white/30"
        }`}
      >
        Trigger Chaos Wheel
      </button>
      <div className="text-[10px] uppercase tracking-widest text-white/30">
        {cooldownLabel}
      </div>
    </div>
  );
}
